<template>
<div
	ref="modalRef"
	class="modal fade"
	tabindex="-1"
	aria-labelledby="modal-label"
	aria-hidden="true"
	data-bs-keyboard="false"
	data-bs-backdrop="static"
>
	<div class="modal modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-lg-down">
		<div class="modal-content px-3">
			<div class="modal-header">
				<h1 class="modal-title fs-5">
					<span v-if="title">{{ title }}</span>
				</h1>
				<button type="button" class="btn-close" aria-label="Close" @click="close(0,'close')"></button>
			</div>

			<div class="modal-body">
				<slot name="body">
					Чи згодні ви продовжити?
				</slot>
			</div>

			<div class="modal-footer">
				<button
					v-if="rejectButtonTitle.length > 0"
					type="button"
					class="btn btn-secondary w-25"
					:class="{'me-5': confirmButtonTitle.length > 0}"
					:disabled="!isButtonsEnabled"
					@click="onCancel()"
				>
					{{ rejectButtonTitle }}
				</button>
				<button
					v-if="confirmButtonTitle.length > 0"
					type="button"
					class="btn btn-primary w-25"
					:disabled="!isButtonsEnabled"
					@click="onConfirm()"
				>
					{{ confirmButtonTitle }}
				</button>
			</div>
		</div>
	</div>
</div>
</template>


<script>
import { Modal } from "bootstrap"
import { nextTick } from "vue"


export default {
	waitAfterClose: 700,
	
	props: {
		// Popup state
		show: {
			type: Boolean,
			required: true,
			default: false
		},

		title: {
			type: String,
			required: false,
			default: "Підтвердіть виконання запиту",
		},

		confirmButtonTitle: {
			type: String,
			required: false,
			default: "Так",
		},

		rejectButtonTitle: {
			type: String,
			required: false,
			default: "Ні",
		},
	},

	emits: [
		'update:show', // popup state feedback
		'confirm',
		'close',
	],

	data() {
		return {
			// modal component object
			modal: null,
			// Modal hide handler
			handleHidePrevented: null,
			// Buttons state
			isButtonsEnabled: true,			
		}
	},

	created() {},

	async mounted() {
		nextTick(() => {
			this.$watch(() => this.show, (newVal) => {
				if (newVal) {
					// Show modal popup
					this.modal.show()
					this.isButtonsEnabled = true
				} else {
					// Hide modal popup
					this.modal.hide()
				}
			})

			// Get modal object
			this.modal = new Modal(this.$refs.modalRef)

			this.handleHidePrevented = () => {
				this.close(0, 'close')
			}

			//console.log("Created popup", this.modal)

			if (this.modal) {
				// This event is fired when the modal is shown, its backdrop is static
				// and a click outside of the modal is performed. The event is also
				// fired when the escape key is pressed and the keyboard option is set to false.
				this.$refs.modalRef.addEventListener(
					'hidePrevented.bs.modal',
					this.handleHidePrevented,
				)
			}
		})
	},

	beforeUnmount() {
		if (this.modal && this.handleHidePrevented) {
			// Remove event listener which created in mounted()
			this.$refs.modalRef.removeEventListener(
				'hidePrevented.bs.modal',
				this.handleHidePrevented,
			)
		}
	},

	methods: {
		onCancel() {
			this.isButtonsEnabled = false
			this.close(0, 'close')
		},

		onConfirm() {
			this.isButtonsEnabled = false
			this.close(this.$options.waitAfterClose, 'confirm')
		},

		// Close popup
		close(timeout, emit) {
			//console.log(`Close, emit=${emit}`)

			if (timeout > 0) {
				setTimeout(
					() => {
						this.$emit(emit);
						this.$emit('update:show', false)
					},
					timeout,
				)
			} else{
				this.$emit(emit);
				this.$emit('update:show', false)
			}
		},
	},

	computed: {
		//capitalizeFirstLetter() { return capitalizeFirstLetter },
	},
};
</script>


<style scoped>
</style>
	